/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiResponse } from '../../types/apiTypes';
import { Location } from '../../types/locationTypes';
import { User } from '../../types/userTypes';

export interface UsersState {
  users: ApiResponse<User>;
  selectedUser: User | null;
  selectedUserLocations: Location[] | null;
  fetchUsersLoading: boolean;
  describeUserLoading: boolean;
  updateUserLoading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  users: { data: [], meta: null, totalCount: 0, filteredCount: 0 },
  selectedUser: null,
  selectedUserLocations: null,
  fetchUsersLoading: false,
  describeUserLoading: false,
  updateUserLoading: false,
  error: null,
};

type UsersLoadingKey =
  | 'fetchUsersLoading'
  | 'describeUserLoading'
  | 'updateUserLoading';

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    fetchSelectedUserLocations(
      _state,
      _action: PayloadAction<{ orgId: number; userId: number }>,
    ) {},
    setSelectedUserLocations(state, action: PayloadAction<Location[]>) {
      state.selectedUserLocations = action.payload;
    },

    setLoading(
      state,
      action: PayloadAction<{ key: UsersLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.fetchUsersLoading = false;
      state.describeUserLoading = false;
    },

    clearUsers(state) {
      state.users = initialState.users;
    },
    clearSelectedUser(state) {
      state.selectedUser = initialState.selectedUser;
    },
    clearUsersState() {
      return initialState;
    },
  },
});

export const {
  fetchSelectedUserLocations,
  setSelectedUserLocations,
  clearUsers,
  clearSelectedUser,
  clearUsersState,
} = usersSlice.actions;

export const usersActions = usersSlice.actions;
export default usersSlice.reducer;
